// Total number of non-Japanese languages supported (must match backend LANGUAGE_LABEL_MAP excluding ja)
// Includes Tagalog (tl / タガログ語) added as the 9th non-Japanese language
export const TOTAL_NON_JP_LANGUAGES = 9;
